import { render, staticRenderFns } from "./RFQDetail.vue?vue&type=template&id=62abac08&"
import script from "./RFQDetail.vue?vue&type=script&lang=js&"
export * from "./RFQDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports